import { supabase } from "@/integrations/supabase/client";
import { projectsAPI } from "./projects";
import { entriesAPI } from "./entries";
import { peopleAPI } from "./people";
import { materialsAPI } from "./materials";
import { constructionStagesAPI } from "./construction-stages";
import { unitsAPI } from "./units";
import { reportsAPI } from "./reports";

// Define the export API
export const exportAPI = {
  /**
   * Export all user data to CSV format
   * This will collect all data from various tables that belong to the current user
   */
  async getAllUserData() {
    // Get current user session
    const { data: { session } } = await supabase.auth.getSession();
    
    if (!session) {
      
      throw new Error('User not authenticated');
    }
    
    const userId = session.user.id;
    
    
    try {
      // Get projects
      const { data: projects, error: projectsError } = await projectsAPI.getProjects();
      
      if (projectsError) {
        
        throw new Error(`Failed to fetch projects: ${projectsError.message}`);
      }
      
      
      
      // Collect all data in parallel
      const [
        entriesResult,
        peopleResult,
        materialsResult,
        constructionStagesResults,
        unitsResults,
        reportsResult
      ] = await Promise.all([
        entriesAPI.getEntries().catch(err => {
          
          return [];
        }),
        peopleAPI.getPeople().catch(err => {
          
          return [];
        }),
        materialsAPI.getMaterials().catch(err => {
          
          return [];
        }),
        Promise.all((projects || []).map(project => 
          constructionStagesAPI.getStages(project.id).catch(err => {
            
            return { data: [], error: err };
          })
        )),
        Promise.all((projects || []).map(project => 
          unitsAPI.getUnits(project.id).catch(err => {
            
            return { data: [], error: err };
          })
        )),
        reportsAPI.getReports().catch(err => {
          
          return { data: [], error: err };
        })
      ]);
      
      // Flatten construction stages and units arrays
      const constructionStages = constructionStagesResults.flatMap(result => result.data || []);
      const units = unitsResults.flatMap(result => result.data || []);
      
      
      
      return {
        projects: projects || [],
        entries: entriesResult || [],
        people: peopleResult || [],
        materials: materialsResult || [],
        constructionStages,
        units,
        reports: reportsResult?.data || []
      };
    } catch (error) {
      
      throw error;
    }
  }
}; 